import { create } from 'zustand';

interface PageDirtyStoreState {
  confirmationHref: string | null;
  isPageDirty: boolean;
  setIsPageDirty: (isDirty: boolean) => void;
  clear: () => void;
  setShowConfirmationWithHref: (v: string | null) => void;
  setShouldValidateCache: (v: boolean) => void;
  shouldValidateCache: boolean;
}

export const usePageDirtyStore = create<PageDirtyStoreState>((set) => ({
  confirmationHref: null,
  isPageDirty: false,
  shouldValidateCache: false,
  setIsPageDirty: (isDirty: boolean) => set({ isPageDirty: isDirty }),
  clear: () => set({ isPageDirty: false, confirmationHref: null }),
  setShowConfirmationWithHref: (v: string | null) => set({ confirmationHref: v }),
  setShouldValidateCache: (v: boolean) => set({ shouldValidateCache: v }),
}));
